<template>
  <div>
    404 Not Found
    <hr>
    <router-link to="/">Top</router-link>
  </div>
</template>

<script>
export default {
  name:"notfound"
}
</script>